import { inject, Injectable } from '@angular/core';

import { ServerName } from '@graphql/shared/enums/server-name.enum';
import { GraphQLService } from '@graphql/shared/services/graphql.service';
import { QueryResult } from '@graphql/shared/types/query-result.type';

import { GET_USER_BY_ID, GetUserByIdResult } from '../queries/get-user-by-id.query';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private readonly graphQLService = inject(GraphQLService);

  getUserById(id: string): QueryResult<GetUserByIdResult> {
    return this.graphQLService.query(
      {
        query: GET_USER_BY_ID,
        variables: { id },
        fetchPolicy: 'cache-first',
      },
      ServerName.RBSGraphQL,
    );
  }
}
